/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {confirmIosDonation} from '../api'

export const useMutationConfirmIosDonation = createReactQueryMutationHook('confirmIosDonation', confirmIosDonation)
